export enum MFAPhase {
  Disabled = 0,
  SkipFirst = 1,
  CreatePasswordFirst = 2,
  CreatePasswordOnly = 3,
}
